import React, { PureComponent } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroller";
import { applySelectorsToCards } from "../selectors/cards";
import Card from "./Card";
import FlipMove from "react-flip-move";

class CardListing extends PureComponent {
  state = {
    cursor: 10
  };

  loadMore = () => {
    this.setState({ cursor: this.state.cursor + 5 });
  };

  render() {
    const { tagFilter, cards } = this.props;
    const filtering = !_.isNull(tagFilter);
    const displayCards = _.take(cards, this.state.cursor);
    const jsonMedia = _.keyBy(JSON.parse(window.drupalSettings.mw_hub.json_media), "mid");

    return (
      <CardListingWrapper>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMore}
          hasMore={this.state.cursor < cards.length}
          style={{width: "100%"}}
        >
          <FlipMove style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
            {displayCards.map((item, index) => {
              return (
                <Card
                  key={item.i}
                  item={item}
                  filtering={filtering}
                  jsonMedia={jsonMedia}
                />
              );
            })}
          </FlipMove>
        </InfiniteScroll>
      </CardListingWrapper>
    );
  }
}

const CardListingWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  clear: both;
`;

const mapStateToProps = state => {
  return {
    cards: applySelectorsToCards(state),
    insights: state.insights,
    tagFilter: state.tagFilter
  };
};

export default connect(mapStateToProps)(CardListing);



// WEBPACK FOOTER //
// ./src/cardListing/components/CardListing.js